import { SportId } from 'app/lib/betting/constants';

import { BasketballScoreboardCells } from './components/Basketball';
import { CounterScoreboardCells } from './components/CounterStrike';
import { DotaScoreboardCells } from './components/Dota';
import { HandballScoreboardCells } from './components/Handball';
import { IceHockeyScoreboardCells } from './components/IceHockey';
import { SoccerScoreboardCells } from './components/Soccer';
import { TableTennisScoreboardCells } from './components/TableTennis';
import { TennisScoreboardCells } from './components/Tennis';
import { VolleyballScoreboardCells } from './components/Volleyball';

// ---

export const getMatchScoreboardCellsComponent = (sportId?: SportId) => {
  switch (sportId) {
    case SportId.SOCCER: return SoccerScoreboardCells;
    case SportId.ICE_HOCKEY: return IceHockeyScoreboardCells;
    case SportId.BASKETBALL: return BasketballScoreboardCells;
    case SportId.HANDBALL: return HandballScoreboardCells;
    case SportId.VOLLEYBALL: return VolleyballScoreboardCells;
    case SportId.TENNIS: return TennisScoreboardCells;
    case SportId.TABLE_TENNIS: return TableTennisScoreboardCells;
    case SportId.DOTA: return DotaScoreboardCells;
    case SportId.CS_GO: return CounterScoreboardCells;

    default:
      console.warn('Unable to get <MatchScoreboardCells /> component by sport id', sportId);

      return () => null;
  }
};
